import Colors from '../../../../themes/Colors';
import styled from 'styled-components'

const ClientsSectionHolder = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    h2 {
      font-family: 'Roboto', sans-serif;
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
      margin: 0;
      color: ${Colors.textStrong};
    }

    .ant-input-search {
      max-width: 280px;
    }
  }

  .clients-list {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 4px;
    cursor: grab;

    /* Keep horizontal scrolling but hide the scrollbar */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE / old Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome / Safari */
    }

    &.dragging {
      cursor: grabbing;
      user-select: none;
    }
  }
`

export default ClientsSectionHolder
